module.exports = __webpack_public_path__ + "img/info-icon-primary.1075ac86.svg";